import webhooksSaga, {
  deleteWebhook,
  editWebhook,
  getWebhooks,
  saveWebhook,
  testWebhook,
} from '~/sagas/webhooks/webhooks.saga';

export default webhooksSaga;

export { deleteWebhook, editWebhook, getWebhooks, saveWebhook, testWebhook };
